var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0.75V2.25M9.75 9.75V11.25M9.75 5.25V6.75M1.5 3.75C2.09674 3.75 2.66904 3.98705 3.09099 4.40901C3.51295 4.83097 3.75 5.40326 3.75 6C3.75 6.59674 3.51295 7.16903 3.09099 7.59099C2.66904 8.01295 2.09674 8.25 1.5 8.25V9.75C1.5 10.1478 1.65804 10.5294 1.93934 10.8107C2.22065 11.092 2.60218 11.25 3 11.25H15C15.3978 11.25 15.7794 11.092 16.0607 10.8107C16.342 10.5294 16.5 10.1478 16.5 9.75V8.25C15.9033 8.25 15.331 8.01295 14.909 7.59099C14.4871 7.16903 14.25 6.59674 14.25 6C14.25 5.40326 14.4871 4.83097 14.909 4.40901C15.331 3.98705 15.9033 3.75 16.5 3.75V2.25C16.5 1.85218 16.342 1.47064 16.0607 1.18934C15.7794 0.908035 15.3978 0.75 15 0.75H3C2.60218 0.75 2.22065 0.908035 1.93934 1.18934C1.65804 1.47064 1.5 1.85218 1.5 2.25V3.75Z",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.fbc820fa45e4791c71b293a75af93e42.svg";
export { ForwardRef as ReactComponent };